import { Palette } from '@mui/material/styles';
import { FontSize } from '@store/types/UserStoreSlice.type';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MuiAutocomplete = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        padding: '6px 16px',
        height: '36px',
        overflow: 'hidden',
        alignItems: 'center',

        // clear x icon
        paddingRight: '35px !important',

        ':hover': {
          // clear x icon
          paddingRight: '50px !important',

          svg: {
            visibility: 'visible',
          },

          // '.MuiAutocomplete-endAdornment': {
          //   background: 'white',
          // },
        },

        '& .MuiAutocomplete-input': {
          padding: '0px',
        },
        // EC NOTE: i don't think this does anything since popper lives outside of here...
        '& .MuiAutocomplete-popper': {
          backgroundColor: 'background.paper',
          color: 'common.black',
        },
      },
    },
  },
});

export { MuiAutocomplete };
